export default __webpack_public_path__ + "static/media/index.678db872.less";